module.exports = __webpack_public_path__ + "img/9788937454547.63e1e299.jpg";